import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { FaUndo } from "react-icons/fa";

function DeleteClients({ setUpdateTrigger, updateTrigger }) {
  const [deleteClients, setDeleteClients] = useState([])

  useEffect(() => {
    getRestoreClients()
  }, []);

  const handleRestoreClient = async(idClient) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¿Quieres restaurar este elemento?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sí, restaurar",
        denyButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/clients/restore/${idClient}`;
        const token = `Bearer ${sessionStorage.getItem("token")}`;
        const response = await axios.get(url, {
            headers: {
                Authorization: token,
            },
        });

        Swal.fire("¡Restaurado!", "El elemento ha sido restaurado.", "success");
        setUpdateTrigger(!updateTrigger);
        getRestoreClients();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelado");
      }

    } catch (error) {
      
    }
  }

  const getRestoreClients = async() => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/clients/getAllDeleted`;
      const token = `Bearer ${sessionStorage.getItem("token")}`;

      const response = await axios.get(url, { headers: { Authorization: token }});

      setDeleteClients(response.data.data);
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  }

  return (
    <div className='table-responsive'>
      <h3 className="mb-4">Elementos eliminados</h3>
      <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
          <thead>
              <tr>
                  <th>Código</th>
                  <th>Nombre</th>
                  <th>Acciones</th>
              </tr>
          </thead>
          <tbody>
              {deleteClients.map((client) => (
                  <tr key={client.id} data-master-id={client.id}>
                      <td>{client.name}</td>
                      <td>{client.rfc}</td>
                      <td>
                          <FaUndo className='restoreButton' onClick={() => { handleRestoreClient(client.id) }} />
                      </td>
                  </tr>
              ))}
          </tbody>
      </table>
    </div>
  )
}

export default DeleteClients;